// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchSetNotes } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetNotes";

type HandlerType = Handler<{ notes: string }>;

export const TpsDispatchSetNotes: HandlerType = props => {
    props.dispatch({
        type: "xCheckout/SetNotes",
        notes: props.parameter.notes,
    } as any);
};

replaceInChain(chain, DispatchSetNotes, TpsDispatchSetNotes);
